



















import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import type { DsrDirectory } from '@getaccept/lib-shared/src/library/types/dsr-directory';
import { TooltipPlacement } from '../../enums/tooltip-placement';

export default defineComponent({
  name: 'DirectoryName',
  props: {
    directory: {
      type: Object as PropType<DsrDirectory>,
      required: true,
    },
  },
  setup(props) {
    const truncatedName = computed(() =>
      LibraryHelper.getTruncatedText(props.directory.title, 120)
    );

    const path = computed(() => `${props.directory.directory + props.directory.title}/`);

    return {
      truncatedName,
      path,
      TooltipPlacement,
    };
  },
});
